import React from 'react';
import { Grid, Typography } from '@mui/material';

type CardDardProps = {
  card: any;
}

export default function CardData({ card }: CardDardProps) {
  const { value, title } = card;
  const stringValue = typeof value === 'string' ? value : (value)? value.toString().replace(/,/g, ", ") : '';
  return (
    <Grid item xs={12} sx={{marginLeft:'-16px'}}>
      <Typography variant="body2" color="text.secondary" sx={{'color':'#8c8c8c', 'fontWeight': '400', 'fontSize':'14px' }}>
        {title}
      </Typography>
      <Typography sx={{ 'color':'#262626', 'fontWeight': '400', 'fontSize':'15px', 'wordBreak': 'break-word' }} gutterBottom variant="h6" component="div">
        {stringValue ? stringValue : '-'}
      </Typography>
    </Grid>
  );
};
